import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Tab, Tabs, Pagination } from "@mui/material";
import { t } from "i18next";
import NoDataFound from "../../../Shared/NoDataFound/NoDataFound";
import "./ManageCancelations.scss";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { useEffect, useState } from "react";
import { API_RESPONSE, COMMON_CONSTANTS, DIALOG_CONSTANT, STORAGE_KEYS, TOASTER_CONFIGS } from "../../../Utilities/Constants/Constants";
import { GetSessionStorageData, checkEmpty } from "../../../Services/Helpers/Helper";
import moment from "moment";
import ReasonDialog from "../../../Shared/ReasonDialog/ReasonDialog";
import { toast } from "react-toastify";


const ManageCancelations = () => {
    const [value, setValue] = useState("1"); 
    const [ cancelRequestList, setCancelRequestList ] = useState<any>([]);
    const [ hasProducts, setHasProducts ] = useState(false);
    const [dialogOpenStatus, setDialogOpenStatus] = useState(API_RESPONSE.FALSE);
    const [ currentIndex, setCurrentIndex ] = useState(null)
    const dialogTitle = DIALOG_CONSTANT.CANCEL_SLOT_TITLE;
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);

    useEffect(()=>{
        value==="0" ? getCancelRequestList() : getPastRequests();
    },[value,page,rowPerPage]);



   
    

    const getCancelRequestList = () =>{
          axiosInstance.get(API_END_POINTS.CANCEL_REQUEST_LIST + "?page=" +
          page +
          "&limit=" +
          rowPerPage).then((response:any)=>{
            if (response.data.status === API_RESPONSE.TRUE) {
                setCancelRequestList(response.data.result.data);
                setTotalCount(response.data.result.total_page);
                setHasProducts(checkEmpty(response.data.result.data));
            }
          })
    };

    const getPastRequests = () => {
          axiosInstance.get(API_END_POINTS.PAST_CANCEL_REQUESTS+ "?page=" +
          page +
          "&limit=" +
          rowPerPage).then((response:any)=>{
            if (response.data.status === API_RESPONSE.TRUE) {
                setCancelRequestList(response.data.result.data);
                setTotalCount(response.data.result.total_page);
                setHasProducts(checkEmpty(response.data.result.data));
            }
          })
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
      };

      const onCloseDialog = () => {
        setCurrentIndex(null);
        setDialogOpenStatus(API_RESPONSE.FALSE);
      };

      /* Delete slot API call */
    const deleteApiCall = (slotIndex:any,event:any) => {
        let slotData = cancelRequestList[slotIndex];
        let spId = GetSessionStorageData(STORAGE_KEYS.ID);
        /* axiosInstance.delete(API_END_POINTS.SESSIONS_LIST +
           "?service_session_id=" + slotData.session_id +
          "&teach_service_id=" + slotData.teach_service_provider_id +
            "&start_date=" + slotData.start_date +
            "&event_type=" + 1 +
            "&end_date=" + slotData.start_date +
            "&start_time=" + slotData.start_time +
            "&end_time=" + slotData.end_time +
            "&reason=" + event.reason +
            "&status=approved" 
            )
            .then((response:any)=>{
              if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                toast.success(response.data.message, TOASTER_CONFIGS);
                getCancelRequestList();
                setCurrentIndex(null);
              }
            }); */
            let payload ={
                booked_time_slot_id :slotData.booked_time_slot,
                time_slot_id : slotData.time_slot_id,
                status : "approved",
                reason : event.reason
            }
            axiosInstance.put(API_END_POINTS.CANCEL_REQUEST_LIST,payload)
            .then((response:any)=>{
                if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                  toast.success(response.data.message, TOASTER_CONFIGS);
                  getCancelRequestList();
                  setCurrentIndex(null);
                }
              });
      }

      useEffect(()=>{
        if(currentIndex !==null)
             setDialogOpenStatus(true)
       
      },[currentIndex])

        /** update reason for blocking the recreational user */
  const onSubmitReason = (value: any,index:number) => {
    setDialogOpenStatus(false);
    deleteApiCall(index,value)
  };

   /**Handle row per page change */
   const onRowChange = (event: any) => {
    setRowPerPage(parseInt(event.target.value));
  };

  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };


    return(
        <div className="cancelation-wrapper">
                <div className="table-wrapper">

                <div className="basic-detail-wrapper mb-3">
                <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              className="header_tabs"
            >
             {/*  <Tab
                value={"0"}
                label={t("Request")}
              /> */}
              <Tab
                value={"1"}
                label={t("Logs")}
              />
            </Tabs>
          </Box>
                </div>

            <ReasonDialog
             modalState={dialogOpenStatus}
             dialogStatus={onCloseDialog}
             submitReason={onSubmitReason}
             title={dialogTitle}
             id={currentIndex}
            />
            <TableContainer component={Paper}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell className="list-headings">{t("S.NO")}</TableCell>
                    {value ==="0" && <TableCell className="list-headings">{t("Name")}</TableCell>}
                    <TableCell className="list-headings">{t("Session Title")}</TableCell>
                    <TableCell className="list-headings">{t("Slot Date")}</TableCell>
                    <TableCell className="list-headings">{t("Start Time")}</TableCell>
                    <TableCell className="list-headings">{t("End Time")}</TableCell>
                    <TableCell className="list-headings">{t("Reason")}</TableCell>
                    <TableCell className="list-headings">{t("Refund Status")}</TableCell>
                    <TableCell className="list-headings">{t("Requested Date & Time")}</TableCell>
                    {value ==="0" && <TableCell className="list-headings">{t("Actions")}</TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cancelRequestList.map((data: any, index: any) => {
                    return (
                        <>
                        <TableRow key={index + 1}>
                            <TableCell>{page - 1 === 0
                            ? index + 1
                            : (page - 1) * rowPerPage + (index + 1)}</TableCell>
                            {value ==="0" && <TableCell>{data.cancelled_username}</TableCell>}
                            <TableCell>{data.session_title}</TableCell>
                            <TableCell>{moment(data.start_date).locale('en').format(COMMON_CONSTANTS.DMY_FORMAT)}</TableCell>
                            <TableCell>{data.start_time}</TableCell>
                            <TableCell>{data.end_time}</TableCell>
                            <TableCell>{data.reason}</TableCell>
                            <TableCell>{data.is_refund ? 'Paid' : 'In Progress'}</TableCell>                            
                            <TableCell>{moment(data.created_on).locale('en').format(COMMON_CONSTANTS.DMY_FORMAT)}</TableCell>
                            {value ==="0" && <TableCell>
                                <div className="btn-wrap">
                                    <button className="btn btn-success" onClick={()=>{setCurrentIndex((prev)=>index)}}>Accept</button>                                
                                    {/* <button className="btn btn-danger">Ignore</button>                                 */}
                                </div></TableCell>}
                        </TableRow>
                        </>
                    );
                    })}
                    
                </TableBody>
                </Table>
                {!hasProducts && <NoDataFound />}
            </TableContainer>
          
            {hasProducts && (
            <div className="tablePagination">
                <div className="row">
                <div className="col-md-7">
                    <div className="pagination-wrap">
                    <Pagination
                        count={totalPage}
                        page={page}
                        onChange={handleChangePage}
                    />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="rows-per-page">
                    <p>{t("Rows per page")}:</p>
                    <select
                        className="rows-select"
                        value={rowPerPage}
                        onChange={onRowChange}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                    </select>
                    </div>
                </div>
                </div>
            </div>
            )}
            </div>
        </div>
    )

};

export default ManageCancelations;